<template>
	<QrcodeNavCardShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavCardShell from '../shared/QrcodeNavCardShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavCard',
		components: { QrcodeNavCardShell },
		mixins: [qrcodeNavMixin],
	};
</script>
